var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "instagram",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00279 3.89258C5.73413 3.89258 3.89746 5.73125 3.89746 7.99791C3.89746 10.2666 5.73613 12.1032 8.00279 12.1032C10.2715 12.1032 12.1081 10.2646 12.1081 7.99791C12.1081 5.72925 10.2695 3.89258 8.00279 3.89258ZM8.00279 10.6626C6.53013 10.6626 5.33813 9.46991 5.33813 7.99791C5.33813 6.52591 6.53079 5.33325 8.00279 5.33325C9.47479 5.33325 10.6675 6.52591 10.6675 7.99791C10.6681 9.46991 9.47546 10.6626 8.00279 10.6626Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2988 0.0512343C9.82681 -0.0174323 6.18082 -0.014099 4.70748 0.0512343C3.41282 0.111901 2.27082 0.424568 1.35015 1.34523C-0.188515 2.8839 0.0081515 4.95723 0.0081515 7.9979C0.0081515 11.1099 -0.165182 13.1352 1.35015 14.6506C2.89482 16.1946 4.99815 15.9926 8.00281 15.9926C11.0855 15.9926 12.1495 15.9946 13.2395 15.5726C14.7215 14.9972 15.8401 13.6726 15.9495 11.2932C16.0188 9.82057 16.0148 6.17523 15.9495 4.7019C15.8175 1.89323 14.3101 0.189901 11.2988 0.0512343ZM13.6288 13.6326C12.6201 14.6412 11.2208 14.5512 7.98348 14.5512C4.65015 14.5512 3.31348 14.6006 2.33815 13.6226C1.21482 12.5046 1.41815 10.7092 1.41815 7.98723C1.41815 4.3039 1.04015 1.65123 4.73682 1.4619C5.58615 1.4319 5.83615 1.4219 7.97415 1.4219L8.00415 1.4419C11.5568 1.4419 14.3441 1.0699 14.5115 4.7659C14.5495 5.60923 14.5581 5.86257 14.5581 7.99723C14.5575 11.2919 14.6201 12.6366 13.6288 13.6326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2706 4.68916C12.8004 4.68916 13.2299 4.25966 13.2299 3.72984C13.2299 3.20001 12.8004 2.77051 12.2706 2.77051C11.7408 2.77051 11.3113 3.20001 11.3113 3.72984C11.3113 4.25966 11.7408 4.68916 12.2706 4.68916Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6648 2.65667H12.1254V0.112667C11.8734 0.078 11.0068 0 9.99742 0C7.89142 0 6.44876 1.32467 6.44876 3.75933V6H4.12476V8.844H6.44876V16H9.29809V8.84467H11.5281L11.8821 6.00067H9.29742V4.04133C9.29809 3.21933 9.51942 2.65667 10.6648 2.65667Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.356 4.742C15.0067 4.28 15.554 3.70333 16 3.03933V3.03867C15.4047 3.29933 14.7713 3.47267 14.11 3.55667C14.79 3.15067 15.3093 2.51267 15.5533 1.744C14.9193 2.122 14.2193 2.38867 13.4733 2.538C12.8713 1.89667 12.0133 1.5 11.0773 1.5C9.26133 1.5 7.79933 2.974 7.79933 4.78067C7.79933 5.04067 7.82133 5.29067 7.87533 5.52867C5.14866 5.39533 2.73533 4.08867 1.114 2.09733C0.831333 2.58867 0.664666 3.15067 0.664666 3.75533C0.664666 4.89133 1.24933 5.898 2.122 6.48133C1.59467 6.47133 1.078 6.318 0.64 6.07733V6.11333C0.64 7.70733 1.77667 9.03133 3.268 9.33667C3.00066 9.41 2.71 9.44467 2.408 9.44467C2.198 9.44467 1.986 9.43267 1.78733 9.38867C2.212 10.6873 3.41866 11.6427 4.852 11.674C3.736 12.5467 2.31867 13.0727 0.784666 13.0727C0.516 13.0727 0.258 13.0607 0 13.028C1.45333 13.9647 3.17466 14.5 5.032 14.5C10.8207 14.5 14.5933 9.67067 14.356 4.742Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "linkedin",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9959 15.9994V15.9988H15.9999V10.1308C15.9999 7.26015 15.3819 5.04883 12.0259 5.04883C10.4125 5.04883 9.32985 5.93416 8.88785 6.77349H8.84119V5.31683H5.65918V15.9988H8.97252V10.7095C8.97252 9.31681 9.23652 7.97015 10.9612 7.97015C12.6605 7.97015 12.6859 9.55947 12.6859 10.7988V15.9994H15.9959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.263916 5.31836H3.58125V16.0004H0.263916V5.31836Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92133 0C0.860667 0 0 0.860667 0 1.92133C0 2.982 0.860667 3.86067 1.92133 3.86067C2.982 3.86067 3.84267 2.982 3.84267 1.92133C3.842 0.860667 2.98133 0 1.92133 0V0Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "medium",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.281 11.856c0 3.143-2.525 5.69-5.64 5.69-3.115 0-5.641-2.548-5.641-5.69 0-3.141 2.525-5.69 5.64-5.69 3.116 0 5.641 2.548 5.641 5.69ZM19.469 11.857c0 2.957-1.263 5.356-2.82 5.356-1.558 0-2.82-2.399-2.82-5.357 0-2.957 1.262-5.356 2.82-5.356 1.557 0 2.82 2.398 2.82 5.357M22 11.857c0 2.65-.444 4.798-.992 4.798s-.991-2.148-.991-4.798.444-4.799.991-4.799c.548 0 .992 2.148.992 4.799Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "telegram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.237 10.888C9.07 8.63 12.291 7.14 13.903 6.422c4.603-2.053 5.56-2.41 6.183-2.422.137-.002.444.034.642.207.168.146.214.343.236.481.022.139.05.454.028.7-.25 2.811-1.329 9.633-1.878 12.781-.232 1.333-.69 1.78-1.133 1.823-.962.095-1.693-.682-2.625-1.338-1.459-1.025-2.283-1.664-3.7-2.665-1.636-1.156-.575-1.792.358-2.831.244-.272 4.485-4.41 4.567-4.785.01-.047.02-.222-.077-.314s-.24-.06-.343-.036c-.147.036-2.477 1.688-6.992 4.957-.661.487-1.26.724-1.797.712-.592-.014-1.73-.359-2.577-.654-1.038-.362-1.862-.553-1.79-1.168.037-.32.448-.647 1.232-.982Z",
    clipRule: "evenodd"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "discord",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.24 10.39c-.57 0-1.02.5-1.02 1.11 0 .61.46 1.11 1.02 1.11.57 0 1.02-.5 1.02-1.11.01-.61-.45-1.11-1.02-1.11Zm3.65 0c-.57 0-1.02.5-1.02 1.11 0 .61.46 1.11 1.02 1.11.57 0 1.02-.5 1.02-1.11 0-.61-.45-1.11-1.02-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2H5.35C4.22 2 3.3 2.92 3.3 4.06v13.52c0 1.14.92 2.06 2.05 2.06h11.34l-.53-1.85 1.28 1.19 1.21 1.12L20.8 22V4.06c0-1.14-.92-2.06-2.05-2.06Zm-3.86 13.06s-.36-.43-.66-.81c1.31-.37 1.81-1.19 1.81-1.19-.41.27-.8.46-1.15.59-.5.21-.98.35-1.45.43-.96.18-1.84.13-2.59-.01-.57-.11-1.06-.27-1.47-.43-.23-.09-.48-.2-.73-.34-.03-.02-.06-.03-.09-.05-.02-.01-.03-.02-.04-.03-.18-.1-.28-.17-.28-.17s.48.8 1.75 1.18c-.3.38-.67.83-.67.83-2.21-.07-3.05-1.52-3.05-1.52 0-3.22 1.44-5.83 1.44-5.83 1.44-1.08 2.81-1.05 2.81-1.05l.1.12c-1.8.52-2.63 1.31-2.63 1.31s.22-.12.59-.29c1.07-.47 1.92-.6 2.27-.63.06-.01.11-.02.17-.02a8.152 8.152 0 0 1 5.03.94s-.79-.75-2.49-1.27l.14-.16s1.37-.03 2.81 1.05c0 0 1.44 2.61 1.44 5.83 0 0-.85 1.45-3.06 1.52Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "web",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 7.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 0.799805C6.93343 1.86647 5.6001 3.1998 5.6001 7.9998C5.6001 12.7998 6.93343 14.1331 8.0001 15.1998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 0.799805C9.06657 1.86647 10.3999 3.1998 10.3999 7.9998C10.3999 12.7998 9.06657 14.1331 7.9999 15.1998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 8H15.2"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.659 9.708a.212.212 0 0 1 .341.165v7.19c0 .931-.756 1.687-1.688 1.687H4.688A1.688 1.688 0 0 1 3 17.062V9.878c0-.176.2-.275.341-.166.788.612 1.832 1.389 5.418 3.994.741.541 1.993 1.68 3.241 1.674 1.255.01 2.531-1.154 3.245-1.674 3.586-2.605 4.627-3.386 5.414-3.997ZM12 14.25c.816.014 1.99-1.027 2.58-1.456 4.666-3.385 5.02-3.68 6.097-4.524A.841.841 0 0 0 21 7.605v-.668c0-.931-.756-1.687-1.688-1.687H4.688C3.756 5.25 3 6.006 3 6.938v.667c0 .26.12.503.323.665 1.076.84 1.431 1.139 6.097 4.524.59.43 1.764 1.47 2.58 1.456Z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-youtube",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.5c-.14-.48-.4-.92-.77-1.26a3.05 3.05 0 0 0-1.33-.74C19.52 4 12 4 12 4c-3.14-.03-6.28.12-9.4.47-.5.14-.96.4-1.33.76-.37.36-.64.8-.78 1.28C.15 8.3-.01 10.16 0 12 0 13.83.15 15.67.5 17.5c.14.47.4.91.77 1.26.37.36.84.61 1.34.75 1.9.5 9.4.5 9.4.5 3.14.03 6.28-.13 9.4-.48.5-.13.96-.38 1.33-.74.37-.35.64-.8.77-1.27.34-1.81.51-3.65.5-5.5.03-1.85-.14-3.7-.5-5.51ZM9.6 15.44V8.58L15.86 12 9.6 15.43Z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.34 6.34 11.32 11.32M6.34 17.66 17.66 6.34",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-spinner",
    fill: "none",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2a7 7 0 1 0 6.66 4.84",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-spinner-thin",
    fill: "none",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1a8 8 0 1 0 7.6 5.53",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 8-.707.707.707.707.707-.707L6 8ZM1.293 4.707l4 4 1.414-1.414-4-4-1.414 1.414Zm5.414 4 4-4-1.414-1.414-4 4 1.414 1.414Z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-close",
    fill: "none",
    viewBox: "0 0 6 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 1 1 5M1 1l4 4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pen",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.33 2A1.88 1.88 0 1 1 14 4.67l-9 9-3.67 1 1-3.67 9-9Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7h16M4 12h16M4 17h16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-close",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.34 6.34 11.32 11.32M6.34 17.66 17.66 6.34",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-referral",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 19v-1.33c0-.71-.34-1.39-.94-1.89-.6-.5-1.41-.78-2.26-.78H6.2c-.85 0-1.66.28-2.26.78-.6.5-.94 1.18-.94 1.89V19M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18.55 8.73v4.9M21 11h-5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    fill: "none",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5v7M2.5 6h7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-lg",
    fill: "icon-plus-lg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.8v-1.5c.7 0 1.2-.6 1.2-1.2V6c0-.7-.6-1.2-1.2-1.2h-8c-.7 0-1.2.5-1.2 1.2H7.2c0-1.5 1.2-2.8 2.8-2.8h8c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.3 2.8-2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.8H6A2.8 2.8 0 0 1 3.2 18v-8c0-1.5 1.2-2.8 2.8-2.8h8c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.3 2.8-2.8 2.8zm-8-12c-.7 0-1.2.6-1.2 1.2v8c0 .7.6 1.2 1.2 1.2h8c.7 0 1.2-.6 1.2-1.2v-8c0-.7-.6-1.2-1.2-1.2H6z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copied",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.8c-.4 0-.8-.3-.8-.8s.3-.8.8-.8c.7 0 1.2-.6 1.2-1.2V6c0-.7-.6-1.2-1.2-1.2h-8c-.7 0-1.2.5-1.2 1.2 0 .4-.3.8-.8.8s-.8-.4-.8-.8c0-1.5 1.2-2.8 2.8-2.8h8c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.3 2.8-2.8 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.8H6A2.8 2.8 0 0 1 3.2 18v-8c0-1.5 1.2-2.8 2.8-2.8h8c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.3 2.8-2.8 2.8zm-8-12c-.7 0-1.2.6-1.2 1.2v8c0 .7.6 1.2 1.2 1.2h8c.7 0 1.2-.6 1.2-1.2v-8c0-.7-.6-1.2-1.2-1.2H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 16.1c-.2 0-.4-.1-.5-.2l-1.3-1.3c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l.8.7 2.3-2.2c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-2.8 2.8c-.3.2-.5.2-.7.2z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nfts",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4L4 8L12 12L20 8L12 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16L12 20L20 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12L12 16L20 12"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.11 20.75a.75.75 0 0 1-.75-.75v-1.78a2.79 2.79 0 0 0-2.8-2.8H8.44a2.79 2.79 0 0 0-2.8 2.8V20a.75.75 0 0 1-1.5 0v-1.78a4.28 4.28 0 0 1 4.3-4.3h7.12a4.27 4.27 0 0 1 4.3 4.3V20c0 .41-.34.75-.75.75zM12 11.86a4.31 4.31 0 1 1 .01-8.62 4.31 4.31 0 0 1-.01 8.62zm0-7.11a2.8 2.8 0 1 0 0 5.62 2.8 2.8 0 0 0 0-5.62z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logout",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17 16 4-4-4-4M21 12H9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.75a.75.75 0 0 0 0-1.5v1.5Zm0 14a.75.75 0 0 0 0-1.5v1.5Zm0-15.5H5v1.5h6.5v-1.5ZM2.25 7v10h1.5V7h-1.5ZM5 19.75h6.5v-1.5H5v1.5ZM2.25 17A2.75 2.75 0 0 0 5 19.75v-1.5c-.69 0-1.25-.56-1.25-1.25h-1.5ZM5 4.25A2.75 2.75 0 0 0 2.25 7h1.5c0-.69.56-1.25 1.25-1.25v-1.5Z",
    fill: "currentColor"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down-wallet",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6 8-.7.7.7.71.7-.7L6 8ZM1.3 4.7l4 4 1.4-1.4-4-4-1.4 1.4Zm5.4 4 4-4-1.4-1.4-4 4 1.4 1.4Z",
    fill: "currentColor"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-bold",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 6-4 4M6 6l4 4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-blockasset-logo",
    viewBox: "0 0 351.6 406"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoA)",
    d: "M252.8 247.45v-88.91l-77-44.45-77 44.45v88.91l77 44.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logoB)",
    d: "m175.8 0-77 44.46v55.19l77-44.45 128 73.9v147.8l-128 73.9-128-73.9v-203L0 101.5v203L175.8 406l175.8-101.5v-203z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m175.8 291.91 77-44.46-77.24-44.8-76.76 44.8 77 44.46"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m175.8 350.8-128-73.9L0 304.5l175.56 101.36L351.6 304.5l-47.8-27.6-128 73.9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0 101.5v203l47.77-27.68V73.92zm175.8-46.3V0l-77 44.46v55.19m0 58.89v88.72l77-44.61v-88.56"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-blockasset",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.52 2.98 1.7-1C9.17 1.45 9.97 1 10 1c.04 0 1.85 1.04 4.04 2.3L18 5.57v9.25l-3.96 2.3c-2.19 1.25-4 2.28-4.04 2.28-.04 0-1.85-1.03-4.04-2.29L2 14.83V5.58l1.07-.61 1.1-.62.01 4.6v4.6l2.87 1.66c1.59.91 2.91 1.65 2.95 1.65.04 0 1.36-.74 2.95-1.65l2.87-1.66V6.87l-2.87-1.66-2.93-1.67c-.03 0-2.93 1.63-3.48 1.97a10 10 0 0 1-.03-1.25l.01-1.28ZM6.5 8.17l1.74-1c1.03-.6 1.76-1 1.8-.99l1.77 1 1.69.99v4.07l-1.71 1c-.95.54-1.75.99-1.79.99-.04 0-.84-.45-1.79-1l-1.71-.99V8.17Z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-nft",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.43 4.3c-.7-1.14-1.96-1.89-3.95-2.36l-1.39-.32C11.18 1.17 8.5.9 6.99 3.6c-.23.06-.45.1-.7.19l-1.31.43c-1.9.6-3.05 1.43-3.64 2.6-.6 1.15-.58 2.57.03 4.47l1.07 3.29c.89 2.75 2.33 4.07 4.53 4.07.76 0 1.6-.15 2.54-.46l1.32-.43c.77-.25 1.4-.53 1.92-.85l.43.02c2.53 0 4.06-1.48 4.78-4.59l.82-3.48c.47-1.99.36-3.44-.35-4.58zM9.04 16.77c-2.92.94-4.23.27-5.18-2.65l-1.06-3.3c-.48-1.49-.52-2.55-.13-3.33.4-.78 1.28-1.36 2.77-1.85l.85-.28-.14.54-.81 3.5c-.4 1.69-.37 3.05.11 4.12.14.3.32.59.53.85.74.91 1.95 1.55 3.64 1.95l.46.1-1.04.35zm8.28-8.25L16.5 12c-.71 3.07-2 3.58-3.9 3.4-.36-.03-.78-.1-1.23-.2l-1.4-.34c-.38-.1-.73-.2-1.04-.3-2.2-.79-2.76-2.15-2.13-4.83l.81-3.49c.13-.53.27-.95.42-1.32l.15-.35c.5-1.05 1.2-1.75 2.74-1.75.5 0 1.11.08 1.83.25l1.39.33c1.58.36 2.54.9 3.02 1.67.48.78.53 1.87.16 3.45z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-nav-nft-staked",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.336.997a.75.75 0 0 0-.67 0L1.331 5.164a.75.75 0 0 0 0 1.341l8.333 4.167a.75.75 0 0 0 .67 0l8.334-4.167a.75.75 0 0 0 0-1.341L10.336.997ZM10 9.163 3.344 5.835l6.657-3.329 6.656 3.329L10 9.163Zm-9.005.502a.75.75 0 0 1 1.007-.336l7.998 4 7.997-4a.75.75 0 1 1 .671 1.342l-8.333 4.167a.75.75 0 0 1-.67 0L1.331 10.67a.75.75 0 0 1-.336-1.006Zm0 4.168a.75.75 0 0 1 1.007-.336l7.998 4 7.997-4a.75.75 0 0 1 .671 1.342l-8.333 4.167a.75.75 0 0 1-.67 0l-8.334-4.167a.75.75 0 0 1-.336-1.006Z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "percent",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5ZM3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5ZM18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L18.2929 4.29289ZM17.5 16C16.6716 16 16 16.6716 16 17.5C16 18.3284 16.6716 19 17.5 19C18.3284 19 19 18.3284 19 17.5C19 16.6716 18.3284 16 17.5 16ZM14 17.5C14 15.567 15.567 14 17.5 14C19.433 14 21 15.567 21 17.5C21 19.433 19.433 21 17.5 21C15.567 21 14 19.433 14 17.5Z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "layers",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.447 1.108a1 1 0 0 0-.894 0l-10 5a1 1 0 0 0 0 1.788l10 5a1 1 0 0 0 .894 0l10-5a1 1 0 0 0 0-1.788l-10-5ZM12 10.884 4.236 7.002 12 3.12l7.764 3.882L12 10.884Zm-10.894.67a1 1 0 0 1 1.341-.448L12 15.882l9.553-4.776a1 1 0 1 1 .894 1.789l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.342Zm0 5a1 1 0 0 1 1.341-.446L12 20.884l9.553-4.776a1 1 0 0 1 .894 1.788l-10 5a1 1 0 0 1-.894 0l-10-5a1 1 0 0 1-.447-1.341Z",
    clipRule: "evenodd"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.5523 0 13 0.447715 13 1V4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H13V11H14.5C15.6935 11 16.8381 11.4741 17.682 12.318C18.5259 13.1619 19 14.3065 19 15.5C19 16.6935 18.5259 17.8381 17.682 18.682C16.8381 19.5259 15.6935 20 14.5 20H13V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V20H6C5.44772 20 5 19.5523 5 19C5 18.4477 5.44772 18 6 18H11V13H9.5C8.30653 13 7.16193 12.5259 6.31802 11.682C5.47411 10.8381 5 9.69347 5 8.5C5 7.30653 5.47411 6.16193 6.31802 5.31802C7.16193 4.47411 8.30653 4 9.5 4H11V1C11 0.447715 11.4477 0 12 0ZM11 6H9.5C8.83696 6 8.20107 6.26339 7.73223 6.73223C7.26339 7.20107 7 7.83696 7 8.5C7 9.16304 7.26339 9.79893 7.73223 10.2678C8.20107 10.7366 8.83696 11 9.5 11H11V6ZM13 13V18H14.5C15.163 18 15.7989 17.7366 16.2678 17.2678C16.7366 16.7989 17 16.163 17 15.5C17 14.837 16.7366 14.2011 16.2678 13.7322C15.7989 13.2634 15.163 13 14.5 13H13Z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "trend",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7C16.4477 7 16 6.55228 16 6C16 5.44772 16.4477 5 17 5H23C23.5523 5 24 5.44772 24 6V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V8.41421L14.2071 16.2071C14.0196 16.3946 13.7652 16.5 13.5 16.5C13.2348 16.5 12.9804 16.3946 12.7929 16.2071L8.50001 11.9142L1.70711 18.7071C1.31658 19.0976 0.683417 19.0976 0.292893 18.7071C-0.0976311 18.3166 -0.0976311 17.6834 0.292893 17.2929L7.7929 9.79289C7.98044 9.60536 8.23479 9.5 8.50001 9.5C8.76522 9.5 9.01958 9.60536 9.20711 9.79289L13.5 14.0858L20.5858 7H17Z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "chevrons-right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2929 6.29289C12.6834 5.90237 13.3166 5.90237 13.7071 6.29289L18.7071 11.2929C19.0976 11.6834 19.0976 12.3166 18.7071 12.7071L13.7071 17.7071C13.3166 18.0976 12.6834 18.0976 12.2929 17.7071C11.9024 17.3166 11.9024 16.6834 12.2929 16.2929L16.5858 12L12.2929 7.70711C11.9024 7.31658 11.9024 6.68342 12.2929 6.29289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 6.29289C5.68342 5.90237 6.31658 5.90237 6.70711 6.29289L11.7071 11.2929C12.0976 11.6834 12.0976 12.3166 11.7071 12.7071L6.70711 17.7071C6.31658 18.0976 5.68342 18.0976 5.29289 17.7071C4.90237 17.3166 4.90237 16.6834 5.29289 16.2929L9.58579 12L5.29289 7.70711C4.90237 7.31658 4.90237 6.68342 5.29289 6.29289Z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-play",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.32 7.37a2.9 2.9 0 0 1 0 5.26l-7.71 4C5.55 17.69 3 16.35 3 14.2V5.8c0-2.15 2.55-3.5 4.6-2.43l7.72 4Z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-present",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 10.167v7.167H4.433v-7.167m12.9-3.584H3v3.583h14.333V6.583Zm-7.166 10.75V6.583",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.166 6.583h3.225a1.792 1.792 0 1 0 0-3.583c-2.508 0-3.225 3.583-3.225 3.583Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.167 6.583H6.942a1.792 1.792 0 1 1 0-3.583c2.508 0 3.225 3.583 3.225 3.583Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.1ddd739d32cafdf1215b54857db55d8a.svg";
export { ForwardRef as ReactComponent };